import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoanAppForm } from 'merchant-components'
import { associateAppOptions } from 'merchant-api/spiceroad'

function parseBooleanSearchParam(value: unknown): boolean | undefined {
   if (typeof value === 'boolean') return value;
   if (typeof value === 'string') {
     const normalized = value.trim().toLowerCase();
     return normalized === 'true';
   }
}

// TODO: Delete entire route after XF-528 release
export const Route = createFileRoute('/_merchant/apply/')({
  validateSearch: (search?: Record<string, unknown>): { associate?: boolean } => {
    return {
      associate: parseBooleanSearchParam(search?.associate),
    };
  },
  loaderDeps: ({ search }) => ({ associate: search.associate }),
  loader: async ({ deps, context }) => {
    if (deps?.associate === true) {
      await context.queryClient.ensureQueryData(associateAppOptions());
      const { associate, ...rest } = deps;
      throw redirect({ search: rest, replace: true });
    }
  },
  component: LoanAppForm,
})
